import { createFileRoute } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { Button } from '@/components/ui/button'
import { SiteHeader } from '@/components/site-header'

export const Route = createFileRoute('/unsubscribe')({
  head: () => ({ meta: [{ title: 'Aboneliği iptal et — JUËN' }] }),
  component: UnsubscribePage,
})

function UnsubscribePage() {
  const [state, setState] = useState<'loading' | 'valid' | 'used' | 'invalid' | 'success' | 'error'>('loading')
  const [email, setEmail] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)
  const token = typeof window !== 'undefined' ? new URLSearchParams(window.location.search).get('token') : null

  useEffect(() => {
    if (!token) { setState('invalid'); return }
    fetch(`/email/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(async (r) => {
        const data = await r.json().catch(() => ({}))
        if (r.ok && data.valid) { setEmail(data.email ?? null); setState('valid') }
        else if (data.alreadyUnsubscribed) setState('used')
        else setState('invalid')
      })
      .catch(() => setState('error'))
  }, [token])

  const confirm = async () => {
    if (!token) return
    setSubmitting(true)
    try {
      const r = await fetch('/email/unsubscribe', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token }),
      })
      setState(r.ok ? 'success' : 'error')
    } catch { setState('error') } finally { setSubmitting(false) }
  }

  return (
    <div className="min-h-screen bg-background">
      <SiteHeader />
      <div className="mx-auto max-w-md px-4 py-16 text-center">
        <h1 className="text-2xl font-bold">Aboneliği iptal et</h1>
        <div className="mt-6 rounded-2xl border border-border bg-card p-6 shadow-card">
          {state === 'loading' && <p className="text-muted-foreground">Yükleniyor...</p>}
          {state === 'valid' && (
            <>
              <p className="text-sm text-muted-foreground">
                {email ? <><strong>{email}</strong> adresine gönderilen e-postaları durdurmak istediğine emin misin?</> : 'E-postaları durdurmak istediğine emin misin?'}
              </p>
              <Button className="mt-6" onClick={confirm} disabled={submitting}>
                {submitting ? 'İşleniyor...' : 'Aboneliği iptal et'}
              </Button>
            </>
          )}
          {state === 'used' && <p className="text-muted-foreground">Bu adres zaten abonelikten çıkmış.</p>}
          {state === 'success' && <p className="text-success">Aboneliğin iptal edildi. Bu adrese artık e-posta göndermeyeceğiz.</p>}
          {state === 'invalid' && <p className="text-destructive">Geçersiz veya süresi dolmuş bağlantı.</p>}
          {state === 'error' && <p className="text-destructive">Bir hata oluştu. Lütfen tekrar deneyin.</p>}
        </div>
      </div>
    </div>
  )
}
